import { Component } from "../ecs";
import { EditableComponent } from "../editor";

@EditableComponent
export class PlayerControlComponent implements Component {}
